module.exports = __webpack_public_path__ + "static/media/06_atw_weihnachtskarte.f3194d59.svg";